const initState = {
    'default': {}
}

const uplaodActionReducer = (state = initState, action) => {
    switch (action.type) {
        case 'UPLOAD_ACTION_UPDATE':
            return {
                ...state,
                ...action.actions
            }
        default:
            return state
    }
}

export default uplaodActionReducer